const testimonials = [
  {
    name: "Michelle T.",
    location: "Deerfield Beach, FL",
    rating: 5,
    text: "Our family cruise from Port Everglades was in 8 days and my husband realized his passport had expired. Fast Passport Center got his renewal processed and back to us in 4 days. We made our cruise with time to spare. I still can't believe how fast it was.",
    service: "Passport Renewal",
  },
  {
    name: "Robert K.",
    location: "Pompano Beach, FL",
    rating: 5,
    text: "I had an emergency business trip to Toronto and needed my passport renewed in under a week. The team was incredible — walked me through the exact documents, reviewed everything before I shipped, and I had my passport in hand in 5 days. Highly recommend.",
    service: "Expedited Passport",
  },
  {
    name: "Lisa M.",
    location: "Coconut Creek, FL",
    rating: 5,
    text: "My daughter needed a passport for our Jamaica vacation. We were completely lost about the process for a minor. Fast Passport Center sent us a detailed checklist, told us exactly which clerk to visit in Broward County, and got everything expedited after that. Amazing service.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function DeerfieldBeachTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Broward County Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Deerfield Beach, Pompano Beach, and Coconut Creek who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}